<script setup lang="ts">
import { ExclusiveEventTypes, ExclusivePayEvent } from '~/lib/services/store/catalog/catalog.dtos'

defineProps<{ data: ExclusivePayEvent; message?: string }>()
</script>

<template>
  <div class="md:px-4 lg:px-10">
    <div
      data-test="text-event-message"
      class="flex w-full flex-col gap-4 rounded-lg bg-[#F9F9F9] p-4"
    >
      <div v-if="data.type === ExclusiveEventTypes.PRODUCT_LIMIT_EVENT" class="flex gap-2">
        <img class="h-8 w-8" src="/images/icons/profileSections/info-circle.svg" alt="Image Info" />
        <p class="text-sm">{{ message || data.message }}</p>
      </div>
      <div v-else>
        <div class="text-2xl font-bold">{{ data.title }}</div>
        <p>{{ data.message }}</p>
        <div class="flex w-full items-center justify-between">
          <LinkArrow
            v-if="data.link && data.linkText"
            :link-url="data.link"
            :link-text="data.linkText"
          />
          <img :src="data.imageUrl" class="ml-auto max-h-10" />
        </div>
      </div>
    </div>
  </div>
</template>
